import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=5b001f69"
import script from "./ModuleCard.vue?vue&type=script&lang=ts"
export * from "./ModuleCard.vue?vue&type=script&lang=ts"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=5b001f69&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports